import React from 'react'
import { Pressable, ScrollView, Text, TouchableOpacity, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { AppModal } from './AppModal'
import { Button } from './Button'
import { useWebModalHistory } from '../../hooks/useWebModalHistory'

export function InfoModal({ visible, title, message, onClose, children, variant = 'acknowledge', closeLabel = 'Close help', testID }: {
  visible: boolean; title: string; message?: string; onClose: () => void
  children?: React.ReactNode
  variant?: 'acknowledge' | 'help'
  closeLabel?: string
  testID?: string
}) {
  const insets = useSafeAreaInsets()
  const help = variant === 'help'
  useWebModalHistory({ visible, canDismiss: true, onDismiss: onClose })
  return <AppModal visible={visible} animationType="fade" transparent onRequestClose={onClose}>
    <View style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.6)', alignItems: 'center', justifyContent: 'center',
      ...(help ? { paddingTop: insets.top + 16, paddingBottom: insets.bottom + 16, paddingHorizontal: 16 } : { padding: 24 }),
    }}>
      {help && <Pressable testID={testID ? `${testID}-backdrop` : undefined} accessible={false} onPress={onClose}
        style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }} />}
      <View testID={testID} className={help ? 'w-full bg-paper border-2 border-olive rounded-2xl p-5 gap-3' : 'bg-canvas border border-olive rounded-2xl p-6 gap-4 w-full'}
        style={{ maxWidth: help ? 420 : 360, ...(help ? { maxHeight: '100%' as const, flexShrink: 1 } : {}) }}>
        {help ? <View className="flex-row items-center justify-between gap-3">
          <Text accessibilityRole="header" className="font-stencil text-ink uppercase text-base tracking-widest flex-1">{title}</Text>
          <TouchableOpacity onPress={onClose} accessibilityRole="button" accessibilityLabel={closeLabel}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
            <Text className="font-stencil text-blood text-lg">×</Text>
          </TouchableOpacity>
        </View> : <Text accessibilityRole="header" className="font-stencil text-ink text-lg uppercase">{title}</Text>}
        {help ? <ScrollView style={{ flexGrow: 0, flexShrink: 1 }} contentContainerStyle={{ gap: 12 }}>
          {message && <Text className="font-typed text-ink text-sm">{message}</Text>}
          {children}
        </ScrollView> : <>
          {message && <Text className="font-typed text-ink text-sm">{message}</Text>}
          {children}
        </>}
        {!help && <Button title="OK" textColor="#fff" onPress={onClose} />}
      </View>
    </View>
  </AppModal>
}
